module.exports = __webpack_public_path__ + "static/media/title_nisa.7117b625.svg";